import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { VERIFICATION_REFERENCE_DATA } from '../../constants';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationReferenceData = createAsyncThunk(
  'stop/getVerificationReferenceData',
  async (params) => {
    const config = {
      headers: {
        Authorization: params,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(VERIFICATION_REFERENCE_DATA, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationReferenceSlice = createSlice({
  name: 'stop/verificationReference',
  initialState: null,
  reducers: {
    resetVerificationReference: () => null,
  },
  extraReducers: {
    [getVerificationReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetVerificationReference } = verificationReferenceSlice.actions;

export default verificationReferenceSlice.reducer;
